import { type PartnerOfferActionKind } from '@/api/routes/partners/partners.offers.api';
import {
  type OutlineIconComponent,
  type OutlineIconProps,
} from '@/components/icon/createOutlineIcon';
import { IconBrandWhatsapp } from '@/components/icon/tabler/IconBrandWhatsapp';
import { IconMapPin } from '@/components/icon/tabler/IconMapPin';
import { IconPhone } from '@/components/icon/tabler/IconPhone';
import { IconUserPlus } from '@/components/icon/tabler/IconUserPlus';
import { IconWorld } from '@/components/icon/tabler/IconWorld';

interface Props extends OutlineIconProps {
  kind: PartnerOfferActionKind;
}

const ICONS: Record<PartnerOfferActionKind, OutlineIconComponent> = {
  link: IconWorld,
  whatsapp: IconBrandWhatsapp,
  phone: IconPhone,
  lead: IconUserPlus,
  directions: IconMapPin,
};

/** The glyph of each button kind (menu, button card, detail). */
const OfferActionIcon = ({ kind, ...props }: Props) => {
  const Icon = ICONS[kind];
  return <Icon {...props} />;
};

export default OfferActionIcon;
